
// Not normalized like "(848) 208-8967"
const NOT_NORMALIZED_PHONE = /\([0-9]{3}\) [0-9]{3}\-[0-9]{4}/;

const NORMALIZED_PHONE_PARTS = /([0-9]{3})([0-9]{3})([0-9]{4})/;


const cleanPhoneWithoutCountryCode = (str : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    return str ? str.replace(/[()_-\s+]+/g, '') : '';
}

// +18482088967 -> 8482088967
export const formattedPhone = (phone : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    return phone.replace('+1', '').replace(/\D/g, '').replace(/^(\d)(\d{3})(\d{3})(\d{4}).*/, '($2) $3-$4')
}

export const SimplePhone = (phone : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    return phone.replace('+1', '')
}

// +18482088967 -> (848)208-8967
export const userFriendlyPhone = (phone : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    const withoutCode = SimplePhone(phone);
    const parts = withoutCode.match(NORMALIZED_PHONE_PARTS);

    if (parts) {
        return `(${parts[1]}) ${parts[2]}-${parts[3]}`
    }

    return phone;
}

export const isAnyStylePhone = (phone : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    const isNotNormalizedPhine = NOT_NORMALIZED_PHONE.test(phone);
    const isNormalizedPhine = NORMALIZED_PHONE_PARTS.test(phone);

    return isNotNormalizedPhine || isNormalizedPhine;
}

export const isPhoneNumber = (str : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    let formatted = cleanPhoneWithoutCountryCode(SimplePhone(str));
    return formatted.length === 10;
}

// (848)208-8967 -> +18482088967
export const cleanPhoneFormat = (str : string = '') => {
    console.warn('Deprecated, use models/Agent/Phone.ts instead');
    return `+1${cleanPhoneWithoutCountryCode(str)}`;
}
